<template>
    <div>
        <div class="row">
            <div class="col-md-6 offset-3 mt-8">
                <KTCodePreview>
                    <template v-slot:body>
                        <v-card>
                            <v-card-title>

                                <div class="col-md-9">
                                    <label class="font-weight-bold font-size-h5" style="color: #56648F;" >Ubah Kata Sandi</label><br>
                                </div>
                                <div class="col-md-10 mt-1">
                                     <p  class="font-weight-bold font-size-h5"  style="color: #56648F;">Buat kata sandi baru untuk akun {{user.email}}</p>
                                </div>
                                <div class="col-md-12">
                                    <b-form  >
                                        <b-form-group id="input-group-1" label="Kata Sandi Baru">
                                            <b-form-input :type="showPassword ? 'text' : 'password'" v-model="request.password_before"
                                            placeholder="Masukkan Kata Sandi Baru" required>
                                            </b-form-input>
                                        </b-form-group>

                                        <b-form-group id="input-group-2" label="Ulang Kata Sandi">
                                            <b-form-input :type="showPassword ? 'text' : 'password'" v-model="request.password_after"
                                            placeholder="Ulang Kata Sandi" required>
                                            </b-form-input>
                                        </b-form-group>

                                        <b-form-checkbox v-model="showPassword">
                                            Lihat kata sandi
                                        </b-form-checkbox>
                                        <b-button  @click="onSubmit()" variant="primary">Submit</b-button>
                                    </b-form>
                                </div>   
                            </v-card-title>
                           
                        </v-card>
                    </template>
                </KTCodePreview>
            </div>
        </div>
    </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import axios from "axios";

export default{
    data(){
        return {

            request: {
                password_before : null,
                password_after  : null
            },
            user : [],

        }   
    },

    mounted(){
        this.user = JSON.parse(localStorage.getItem("dataLogin"));
    },

    components: {
        KTCodePreview,
    },

    methods:{

        refreshData(result, alert) {
            if (result.data.meta.code == 200) {
                this.$swal(`Success ${alert} Data`);
               
            } else if (result.data.meta.code == 400) {
                this.$swal(`Failed, ${result.data.meta.message}!`);
                this.getData()
            } else {
                this.$swal(`Failed ${alert} Data`);
            }
        },

        async onSubmit(){
            const form = this.request
            this.changePassword(form);
        },

        async changePassword(form){

            try{
                const formData = {
                    password_before : form.password_before,
                    password_after  : form.password_after
                
                }
                const result = await axios.post(`master/users/update_password`,formData)
                this.refreshData(result,'Store')

            }catch(err){
                this.$swal('Failed');
            }
        }
    }
}
   
</script>